module.exports = "/assets/data/48bad29d4d23d0583a8f0bbb363c732e-TR24.data.json";